export default "__VITE_ASSET__B_0TyKx5__"